
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/link-recovery",
      function () {
        return require("private-next-pages/docs/link/link-recovery.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/link-recovery"])
      });
    }
  